import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.find.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import UnbindModel from '@/views/home/models/unbind-model.vue';
import Questionnaire from '@/views/home/models/questionnaire.vue';
import InputCode from '@/components/input-code.vue';
import UserInfo from '@/components/user-info.vue';
import DownLoadApp from '@/components/down-load-app.vue';
import TopicVideoDialog from '@/components/topic-video-dialog.vue';
import LookVideoDialog from '@/components/look-video-dialog.vue';
import LogoutDialog from '@/views/user-center/dialog/logout.vue';
import QuitExperience from '@/components/quit-experience.vue';
import ActiveConfirm from '@/components/active-confirm.vue';
import { kickLogin } from '@/utils/login';
import { getCodeUrlMixins } from '@/utils/getCodeUrlMixin.js';
import callService from '@/utils/call-service';
import { getSubjectList, getExerciseRecordUrl } from '@/api/modules/study.js';
import { mapGetters } from 'vuex';
import OutlineCache from '@/utils/OutlineCache.js';
import NoFindZxb from '@/components/no-find-zxb.vue';
import { getQuestionnaireList as _getQuestionnaireList, getQuestionnaireUrl as _getQuestionnaireUrl } from '@/api/modules/questionnaire.js';
import GuideDialog from '@/views/guide-dialog/index.vue';
import { toSuspended as _toSuspended } from '@/utils/suspended';
import { playOrPauseVideo } from '@/utils/guide-video';
var cache;
export default {
  name: 'Nav',
  components: {
    LookVideoDialog: LookVideoDialog,
    UnbindModel: UnbindModel,
    Questionnaire: Questionnaire,
    InputCode: InputCode,
    UserInfo: UserInfo,
    DownLoadApp: DownLoadApp,
    TopicVideoDialog: TopicVideoDialog,
    LogoutDialog: LogoutDialog,
    GuideDialog: GuideDialog,
    QuitExperience: QuitExperience,
    ActiveConfirm: ActiveConfirm
  },
  mixins: [getCodeUrlMixins],
  data: function data() {
    var user = JSON.parse(localStorage.getItem('userInfo'));
    return {
      visible: false,
      user: user,
      edu: user.edu,
      showiframeDialog: false,
      showVideoDialog: false,
      showLogoutDialog: false,
      showQuestionnaire: false,
      showQuestionnaireButton: false,
      questionnaireList: [],
      configList: [{
        id: 1,
        name: '个人信息'
      }, {
        id: 2,
        name: '已提交练习'
      }, {
        id: 5,
        name: '打印记录'
      }, {
        id: 6,
        name: '帮助中心'
      }, {
        id: 3,
        name: '关于我们'
      }, {
        id: 4,
        name: '退出登录'
      }],
      downLoadAppShow: false,
      userDownloadFn: null,
      iframeUrl: '',
      iframeTitle: '',
      iframeResult: [],
      showGuideDialog: false,
      activeVisible: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    subjectCode: 'subjectGetters',
    studyBindSuccess: 'studyBindSuccess',
    unBindSubject: 'unBindSubject',
    username: 'username',
    userAvatar: 'userAvatar',
    serviceTitle: 'serviceTitle',
    userMode: 'userMode',
    expandExperience: 'expandExperience'
  })), {}, {
    isExperienceMode: function isExperienceMode() {
      return this.userMode === 'experience';
    },
    showCover: function showCover() {
      return !this.isExperienceMode && this.unBindSubject;
    },
    showExperienceTitle: function showExperienceTitle() {
      return this.isExperienceMode && this.expandExperience;
    }
  }),
  watch: {
    $route: function $route(val) {
      this.showiframeDialog = false;
      this.getQuestionnaireList();
    },
    studyBindSuccess: function studyBindSuccess() {
      this.getSubjects();
    },
    activeVisible: function activeVisible(val) {
      playOrPauseVideo(val ? 'videoPause' : 'videoPlay');
    }
  },
  created: function created() {
    window.addEventListener('message', this.lookVideo);
    cache = OutlineCache.getInstance();
    this.getQuestionnaireList();
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('popstate', function (e) {
      _this.showiframeDialog = false;
    }, false);
  },
  methods: {
    lookVideo: function lookVideo(_ref) {
      var data = _ref.data;
      // 查看视频
      var eventMap = new Map([['playVideo', this.playVideo], ['weakVideoOrNote', this.weakVideoOrNote], ['setServicePageTitle', this.setServicePageTitle], ['routeUrlChange', this.routeUrlChange], ['landingKick', kickLogin], ['redirectUrl', this.setRedirectUrl], ['closeReviewDialog', this.closeReviewDialog], ['closeGuideDialog', this.closeGuideDialog], ['openNewPage', this.childUrlchange], ['toStudy', this.toStudy], ['pdfPreview', this.toPdfPreview], ['guideModal', this.guideModal], ['maintenanceServer', this.toSuspended], ['toggleMaskLoading', this.toggleMaskLoading]]);
      if (!(data !== null && data !== void 0 && data.eventName && eventMap.get(data.eventName))) return;
      eventMap.get(data.eventName)(data); // 暂时音视频播放

      this.pause();
    },
    pause: function pause() {
      // 发送暂停音频、视频的事件
      var serviceIframe = document.getElementById('serviceIframe');
      var iframeWin = serviceIframe ? serviceIframe.contentWindow : null;

      if (iframeWin) {
        iframeWin.postMessage({
          eventName: 'audioAndVideoPause'
        }, '*');
      }
    },
    setRedirectUrl: function setRedirectUrl(data) {
      if (this.$route.query.url && data.url === this.$route.query.url) {
        this.showiframeDialog = false;
        return;
      }

      callService(data.url, this);
    },
    toStudy: function toStudy(data) {
      // 服务项跳转学习页
      if (data && data.boxId) {
        cache.switchBox(this.edu, this.subjectCode, data.boxId);
      } // 切换选中大纲 outLineId virtualId type chapterId outLineType


      if (data && data.outlineId) {
        cache.changeOutline(this.edu, this.subjectCode, data.boxId, {
          outLineId: data.outlineId,
          virtualType: data.virtualType,
          arouseNode: true // 唤起节点，匹配正确的大纲节点

        });
      }

      this.$router.push({
        path: '/study',
        query: {
          t: Date.now()
        }
      });
      setTimeout(function () {
        window.location.reload();
      });
    },
    routeUrlChange: function routeUrlChange(data) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var showDialog, urlParams, serachParams, subject;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$nextTick();

              case 2:
                showDialog = document.querySelectorAll('iframe')[0].name === 'dialog'; // iframe的弹框弹出来了

                if (_this2.$route.query.url !== decodeURIComponent(data.href) && !_this2.showiframeDialog && !showDialog) {
                  // const { origin, pathname } = window.location
                  // const tempPath = `${origin}${pathname}?url=${encodeURIComponent(data.href)}`
                  // window.history.pushState({}, '', tempPath)
                  // window.location.replace(`${origin}${pathname}?url=${encodeURIComponent(data.href)}`)
                  _this2.$router.push({
                    path: _this2.$route.path,
                    query: _objectSpread(_objectSpread({}, _this2.$route.query), {}, {
                      url: data.href
                    })
                  });
                }

                if (!(data.href.includes('subjectId') && _this2.$route.query.url && !showDialog)) {
                  _context.next = 11;
                  break;
                }

                // 在iframe页面url上有subjectId并且弹框没有弹出时，以url上的为准
                urlParams = new URL(data.href);
                serachParams = new URLSearchParams(urlParams.search);
                subject = +serachParams.get('subjectId');

                if (!(subject === -1)) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return");

              case 10:
                // 点错题本进入后端接口给的url是个奇葩的-1
                _this2.$store.dispatch('setSubject', subject);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleShowiframeDialog: function handleShowiframeDialog(params) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$_this3$getCode, result, close;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.getCodeTurn(_objectSpread({
                  obtainMethod: 2
                }, params));

              case 2:
                _yield$_this3$getCode = _context2.sent;
                result = _yield$_this3$getCode.result;

                _this3.$refs.inputCode.inputBlur(); // 暂时音视频播放


                _this3.pause();

                if (result) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 9;
                return _this3.$showModal(NoFindZxb, {}, {
                  noFooter: true,
                  width: '784px',
                  customClass: 'no-find-dialog'
                });

              case 9:
                close = _context2.sent;

                if (!close) {
                  playOrPauseVideo('videoPlay');
                }

                return _context2.abrupt("return");

              case 12:
                _this3.iframeResult = result;
                _this3.iframeTitle = result.outlineName;
                _this3.showiframeDialog = true;

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    playVideo: function playVideo(data) {
      var preciousInteractiveVideoId = data.preciousInteractiveVideoId,
          ansItemId = data.ansItemId,
          bussinessId = data.bussinessId,
          paperId = data.paperId,
          from = data.from,
          ansViewId = data.ansViewId,
          businessSource = data.businessSource; // 区分视频的来源

      var businessSourceData = businessSource ? "&businessSource=".concat(businessSource) : '';
      var baseUrl = this.env === 'online' ? "https://".concat(location.host, "/tcscreen") : this.baseUrl;

      if (from === 1) {
        // 查看解析 || 复习笔记
        this.iframeUrl = "".concat(baseUrl, "/answer/video?preciousInteractiveVideoId=").concat(preciousInteractiveVideoId, "&ansItemId=").concat(ansItemId, "&businessId=").concat(bussinessId, "&paperId=").concat(paperId, "&pageType=2&videoType=2&fromType=").concat(from, "&showWebFullScreenBtn=1").concat(businessSourceData);
      } else if (from === 2 || from === 3) {
        // 错题本 || 笔记
        // ansViewId带给视频播放器
        var ansViewIdString = ansViewId ? "&ansViewId=".concat(ansViewId) : '';
        this.iframeUrl = "".concat(baseUrl, "/answer/video?preciousInteractiveVideoId=").concat(preciousInteractiveVideoId, "&fromType=").concat(from, "&pageType=2&videoType=2").concat(ansViewIdString, "&showWebFullScreenBtn=1").concat(businessSourceData);
      }

      this.showVideoDialog = true;
    },
    weakVideoOrNote: function weakVideoOrNote(data) {
      // 查看薄弱的 特殊处理
      var businessId = data.businessId,
          outlineId = data.outlineId,
          tabType = data.tabType,
          businessSource = data.businessSource;
      var baseUrl = this.env === 'online' ? "https://".concat(location.host, "/tcscreen") : this.baseUrl;
      this.$router.replace({
        path: '/service',
        query: {
          url: "".concat(baseUrl, "/answer/?businessId=").concat(businessId, "&outlineId=").concat(outlineId, "&tabType=").concat(tabType, "&pageType=3&videoType=1&businessSource=").concat(businessSource || '', "&showWebFullScreenBtn=1")
        }
      });
    },
    setServicePageTitle: function setServicePageTitle(data) {
      // 原代码逻辑
      // !this.showiframeDialog && this.$bus.$emit('setServicePageTitle', data)
      // const { show } = data
      // !this.showiframeDialog && typeof show === 'boolean' && this.$store.dispatch('showiframeDialog', show)
      // 设置iframe服务页面的标题以及是否显示学科
      // 要区分dialog是不是弹出来了，防止同时出现两个iframe，学科的展示判断被覆盖
      var title = data.title,
          showSubject = data.showSubject;
      var formatTitle = {
        showSubject: typeof showSubject === 'boolean' ? showSubject : this.serviceTitle.showSubject,
        title: title
      };
      !this.showiframeDialog && this.$store.dispatch('setServicePageTitle', formatTitle);
    },
    // 接收url事件
    childUrlchange: function childUrlchange(data) {
      var url = data.url,
          target = data.target,
          replace = data.replace;

      if (replace) {
        window.location.replace(url);
      } else {
        window.open(url, target);
      }
    },
    closeReviewDialog: function closeReviewDialog() {
      this.$bus.$emit('closeReviewDialog');
    },
    closeGuideDialog: function closeGuideDialog() {
      this.$bus.$emit('closeGuideDialog');
    },
    guideModal: function guideModal(data) {
      this.iframeUrl = data.href;
      this.showGuideDialog = true;
    },
    toggleUnbind: function toggleUnbind() {
      // 体验模式需要弹窗确认
      if (this.isExperienceMode) {
        this.activeVisible = !this.activeVisible;
      } else {
        this.visible = !this.visible;
      }
    },
    toggleMaskLoading: function toggleMaskLoading(_ref2) {
      var visible = _ref2.visible;
      this.$store.dispatch('toggleMaskLoading', visible);
    },
    toggleQuestionnaire: function toggleQuestionnaire() {
      // if (this.questionnaireList.length === 1) {
      //   this.getQuestionnaireUrl(this.questionnaireList[0])
      //   return
      // }
      this.showQuestionnaire = !this.showQuestionnaire;
    },
    closeSelf: function closeSelf(status) {
      this.downLoadAppShow = status;
    },
    getSubjects: function getSubjects() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$getSubjectList, status, data, subject;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getSubjectList({
                  edu: _this4.edu,
                  needAll: false
                });

              case 2:
                _yield$getSubjectList = _context3.sent;
                status = _yield$getSubjectList.status;
                data = _yield$getSubjectList.data;

                if (status === 1) {
                  subject = _this4.subjectCode ? data.find(function (item) {
                    return item.code === _this4.subjectCode;
                  }) || data[0] : data[0];

                  _this4.$store.dispatch('setSubject', subject.code);

                  cache.switchSubject(_this4.edu, subject.code, true);
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 跳转到个人中心
    gotoUserCenter: function gotoUserCenter() {
      this.$router.push('/user-center');
    },
    gotoExerciseRecord: function gotoExerciseRecord() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _yield$getExerciseRec, resData, url;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this5.subjectCode === 0)) {
                  _context4.next = 3;
                  break;
                }

                _this5.$message('请先绑定方法盒子');

                return _context4.abrupt("return");

              case 3:
                _context4.next = 5;
                return getExerciseRecordUrl({
                  codes: ['HW0001'],
                  param: {
                    subjectId: _this5.subjectCode
                  }
                });

              case 5:
                _yield$getExerciseRec = _context4.sent;
                resData = _yield$getExerciseRec.data;
                url = resData[0].content;
                callService(url, _this5);

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 跳转到关于我们
    gotoAboutUS: function gotoAboutUS() {
      // 当不是此页面的时候跳转，在当前页面的时候不做操作
      if (this.$route.path !== '/about-us') {
        this.$router.push('/about-us');
      }
    },
    gotoPrintRecord: function gotoPrintRecord() {
      // 去打印记录页面
      // 当不是此页面的时候跳转，在当前页面的时候不做操作
      if (this.$route.path !== '/print-record') {
        this.$router.push('/print-record');
      }
    },
    // 跳转到pdf预览页面新打开窗口
    toPdfPreview: function toPdfPreview(data) {
      var routeUrl = this.$router.resolve({
        path: '/previewPdf',
        query: {
          baseUrl: data.url,
          taskId: data.taskId
        }
      });
      var tempPage = window.open(routeUrl.href, '_blank');

      if (!tempPage) {
        this.$messageBox.confirm('练习生成成功', {
          confirmButtonText: '去打印',
          cancelButtonText: '关闭',
          center: true,
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'message-confirm',
          showClose: false
        }).then(function (_) {
          window.open(routeUrl.href, '_blank');
        });
      }
    },
    // 跳转帮助中心
    gotoHelpCenter: function gotoHelpCenter() {
      var routeUrl = this.$router.resolve({
        name: 'helpCenter',
        query: {
          url: localStorage.getItem('helpCenterUrl')
        }
      });
      window.open(routeUrl.href, '_blank');
    },
    clickMenu: function clickMenu(item) {
      switch (item.id) {
        case 1:
          this.gotoUserCenter();
          break;

        case 2:
          this.gotoExerciseRecord();
          break;

        case 3:
          this.gotoAboutUS();
          break;

        case 4:
          this.showLogoutDialog = true;
          break;

        case 5:
          this.gotoPrintRecord();
          break;

        case 6:
          this.gotoHelpCenter();
          break;
      }
    },
    // 获取问卷列表
    getQuestionnaireList: function getQuestionnaireList() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _yield$_getQuestionna, status, data;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _getQuestionnaireList();

              case 2:
                _yield$_getQuestionna = _context5.sent;
                status = _yield$_getQuestionna.status;
                data = _yield$_getQuestionna.data;

                if (!(status !== 1)) {
                  _context5.next = 7;
                  break;
                }

                return _context5.abrupt("return");

              case 7:
                _this6.questionnaireList = data; // 体验模式下不展示问卷

                _this6.showQuestionnaireButton = _this6.questionnaireList.length > 0;

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 获取问卷链接
    getQuestionnaireUrl: function getQuestionnaireUrl(item) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var params, _yield$_getQuestionna2, status, data;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                params = {
                  shortId: item.shortId
                };
                _context6.next = 3;
                return _getQuestionnaireUrl(params);

              case 3:
                _yield$_getQuestionna2 = _context6.sent;
                status = _yield$_getQuestionna2.status;
                data = _yield$_getQuestionna2.data;

                if (!(status !== 1)) {
                  _context6.next = 8;
                  break;
                }

                return _context6.abrupt("return");

              case 8:
                window.open(data, '_blank');

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    // 停机维护
    toSuspended: function toSuspended(data) {
      var haltTimestamp = data.haltTimestamp;

      _toSuspended(haltTimestamp);
    }
  }
};